import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';




export class Centerchange{
  CentRequestID: number;
  StudentID: number;
  FormNo: string;
  RequestDate: string;
  ExamInstanceID: number;
  CoursePartID: number;
  BranchID: number;
  CollegeID: number;
  ExamCentreID:number;
  TransferExamCentreID: number;
  ApplicationFees: number;
  ReceivedDate: string;
  ApplicationDDNO: string;
  ApplicationBankName: string;
  ApplicationDDDate: string;
  CollegeChangeRemark:string;
  PaymentMode:string;
  ApplicationStatus: string;
  ApplicationDDConfirm: string;
  ApprovedFlag: string;
  ApprovalDate:string;
  ApprovalRemark: string;
  DeleteFlag: string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  
}
@Injectable({
  providedIn: 'root'
})
export class CenterchangeService {
  
    constructor(private dataService: DataAccessService) { }

    
    public GetCurrentExamCentreForPortal(StudentID,ExamInstanceID,CoursePartID,BranchID) {debugger
      this.dataService.setControllerName = '/PortalExamCentreChange/';
      this.dataService.setMethodName = 'GetCurrentExamCentreForPortal?StudentID='+StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID; 
      return this.dataService.getAll<Centerchange[]>()
    }
    public GetTransferredcenterChangedata(ExamInstanceID,CoursePartID,BranchID,CollegeID) {debugger
      this.dataService.setControllerName = '/PortalExamCentreChange/';
      this.dataService.setMethodName = 'GetExamCentreListForPortal?ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&CollegeID='+CollegeID; 
      return this.dataService.getAll<Centerchange[]>()
    }
    public GetSequenceNO(Formnm) {debugger
      this.dataService.setControllerName = '/PortalBranchChange/';
      this.dataService.setMethodName = 'GetSequenceNO?Formnm='+ Formnm; // setting method name from API controller.
      return this.dataService.getAll<Centerchange[]>()
    }
    public save(data) {debugger
      this.dataService.setControllerName = '/PortalExamCentreChange/';
      this.dataService.setMethodName = 'PostInsertPortalExamCentreChangeNEW'; 
      return this.dataService.add<Centerchange[]>(data) 
    }

    public GetDataforCenterChangeList(StudentID,ExamInstanceID,CoursePartID) {debugger
      this.dataService.setControllerName = '/PortalExamCentreChange/';
      this.dataService.setMethodName = 'GetDataforCenterChangeList?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
      return this.dataService.getAll<Centerchange[]>()
    }

    public CancelCenterChangeApplication(RequestID,StudentID,AcademicInstanceID,ResultQueryCode) {
      this.dataService.setControllerName = '/PortalExamCentreChange/';
      this.dataService.setMethodName = 'CancelCenterChangeApplication?RequestID='+RequestID+'&StudentID='+StudentID+'&AcademicInstanceID='+AcademicInstanceID+'&ResultQueryCode='+ResultQueryCode+'';
      return this.dataService.getAll<Centerchange[]>()
    }
  
 
    public GetUpdatePaymentStatusForCenterChange(merchantTxnNo,ExamInstanceID,ApplicationNO,StudentID) {debugger
      this.dataService.setControllerName = '/Payment/';
      this.dataService.setMethodName = 'GetUpdatePaymentStatusForCenterChange?merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO +'&StudentID='+StudentID; // setting method name from API controller.
      return this.dataService.getAll<Centerchange[]>()
    }
    public CheckCenterRequestStatusForNewRequest(StudentID,ExamInstanceID,CoursePartID) {debugger
      this.dataService.setControllerName = '/PortalExamCentreChange/';
      this.dataService.setMethodName = 'CheckCenterRequestStatusForNewRequest?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
      return this.dataService.getAll<Centerchange[]>()
    }
    public GetDocumentPathForCenterChange(ApplicationNO,ExamInstanceID) {
      this.dataService.setControllerName = '/PortalExamCentreChange/';
      this.dataService.setMethodName = 'GetDocumentPathForCenterChange?ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
      return this.dataService.getAll<Centerchange[]>()
    }
    public GetCenterChangeReport(StudentID,ApplicationNO,ExamInstanceID) {
      this.dataService.setControllerName = '/FormPrintReportCertficatesRequest/';
      this.dataService.setMethodName = 'GetCenterChangeReport?StudentID='+StudentID+'&ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
      return this.dataService.getAll<Centerchange[]>()
    }
}
